import React, { useState, useEffect } from "react"
import { computeCourseAnalytics } from "../../../utils/courseDetailHelpers"

const StatCard = ({ label, value }) => (
  <div className="bg-background border border-border rounded-lg p-4">
    <p className="text-xs text-muted-foreground mb-1">{label}</p>
    <p className="text-2xl font-bold text-foreground">{value}</p>
  </div>
)

const CourseAnalyticsTab = ({ orgId, course }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId || !course?.courseId) return
    computeCourseAnalytics(orgId, course).then((result) => {
      setData(result)
      setLoading(false)
    })
  }, [orgId, course?.courseId])

  if (loading || !data) return <div className="p-8 text-center text-sm text-muted-foreground">Loading analytics...</div>

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <StatCard label="Total Learners" value={data?.totalLearners?.toLocaleString()} />
        <StatCard label="Avg. Completion" value={`${data?.avgCompletion}%`} />
        <StatCard label="Avg. Quiz Score" value={data?.quizAttemptCount ? `${data?.avgQuizScore}%` : "—"} />
        <StatCard label="Capstone Pass Rate" value={`${data?.capstonePassRate}%`} />
        {!course?.pricing?.isFree && <StatCard label="Revenue" value={`$${data?.revenue?.toLocaleString()}`} />}
      </div>
    </div>
  )
}

export default CourseAnalyticsTab